import { useState, useEffect } from "react";
import { MessageCircle, X, Phone, ArrowUp } from "lucide-react";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed bottom-16 right-6 z-50 flex flex-col items-end gap-3">
      {/* Popup */}
      {open && (
        <div
          data-testid="whatsapp-popup"
          className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 w-64 animate-fade-up"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
              <MessageCircle size={18} className="text-white" />
            </div>
            <div>
              <div className="font-bold text-ez-text text-sm font-outfit">EZ Care Pharmacy</div>
              <div className="flex items-center gap-1 text-xs text-green-500 font-jakarta">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full" />
                Online
              </div>
            </div>
          </div>

          <p className="text-ez-muted text-sm font-jakarta mb-4 leading-relaxed">
            Hi there! How can we help you today? Send us a message on WhatsApp or give us a call.
          </p>

          <div className="flex flex-col gap-2">
            <a
              href="https://wa.me/12016742138?text=Hi%20EZ%20Care%20Pharmacy!%20I%20need%20help%20with%20a%20prescription."
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-chat-btn"
              className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 rounded-xl text-sm transition-colors font-outfit"
            >
              <MessageCircle size={16} />
              Chat on WhatsApp
            </a>
            <a
              href="tel:+18625201063"
              data-testid="whatsapp-call-btn"
              className="flex items-center justify-center gap-2 border border-ez-teal text-ez-teal hover:bg-teal-50 font-semibold py-3 rounded-xl text-sm transition-colors font-outfit"
            >
              <Phone size={16} />
              Call (862) 520-1063
            </a>
          </div>
        </div>
      )}

      {/* Scroll to top */}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="w-10 h-10 bg-white border border-gray-200 text-ez-teal rounded-full shadow-lg flex items-center justify-center hover:bg-teal-50 hover:scale-110 transition-all duration-300"
          aria-label="Scroll to top"
        >
          <ArrowUp size={18} />
        </button>
      )}

      {/* Main FAB */}
      <button
        data-testid="whatsapp-fab"
        onClick={() => setOpen(!open)}
        className="whatsapp-btn w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110"
        aria-label={open ? "Close chat" : "Open WhatsApp chat"}
      >
        {open ? <X size={22} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
}
